import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemOrganizationLevel extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          {this.props.item.ma}
        </td>
        <td>
          {this.props.item.ten}
        </td>
        <td>
          {this.props.item.capCoQuanQuanLyCha ? this.props.item.capCoQuanQuanLyCha.ten : ''}
        </td>
        <td>
          {this.props.item.moTa}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('CAPCOQUANQUANLY_THEM') ?
                <Link
                  className="itt-add"
                  onClick={this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item)}
                  >
                  Thêm cấp con
                </Link>
              : null
            }
            {
              CheckPermission('CAPCOQUANQUANLY_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                  >
                  Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('CAPCOQUANQUANLY_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.capCoQuanQuanLyId}
                  />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemOrganizationLevel.jsx